<template>
    <div id="myConfig">

        <div class="section1">
            <h4>提现配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">最小提现金额：</label>
                    <el-input style="width:120px;" v-model="cashoutMinAmount" placeholder="请输入"></el-input> 元
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">单笔手续费率：</label>
                    <el-input style="width:120px;" v-model="cashoutFee" placeholder="请输入"></el-input> /百分比
                </el-col>
                <el-col :span="7">
                    <label style="width:120px;">提现间隔天数：</label>
                    <el-input style="width:120px;" v-model="cashoutData" placeholder="请输入"></el-input> 天
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="saveWithdrawConfigHandle()">保 存</el-button>
                </el-col>
            </el-row>
        </div>

        <div v-if="flag == true" class="section1">
            <h4>购卡配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">购卡金额：</label>
                    <el-input style="width:120px;" v-model="buyCardCost" placeholder="请输入"></el-input> 元
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">是否允许购卡：</label>
                    <el-select v-model="isNable" placeholder="请选择" clearable>
                        <el-option value="1" label="允许"></el-option>
                        <el-option value="0" label="不允许"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary" @click="updateBuyCardCost()">保 存</el-button>
                </el-col>
            </el-row>
        </div>

        <div v-if="flag == true" class="section1">
            <h4>预充值配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">手续费：</label>
                    <el-input style="width:120px;" v-model="invent" placeholder="请输入"></el-input> /百分比
                </el-col>


                <el-col :span="1">
                    <el-button type="primary" @click="updateBuyCardCost1()">保 存</el-button>
                </el-col>
            </el-row>
        </div>



        <div class="section1">
            <h4>微信登录页面滚动条内容</h4>
            <el-row>
                <el-col :span="7">
                    <el-input v-model="loginRemark" label="请输入"></el-input>
                </el-col>
                <el-col style="width:100px;" :span="1">
                    <el-button type="primary" @click="setLoginRemark">更新</el-button>
                </el-col>

            </el-row>

        </div>


        <div class="section1">
            <h4>微信登录页面宣传图</h4>
            <el-row>
                <el-col :span="7">
                    <input type="file" ref="file1">
                    <div >上传图(建议尺寸658 x 548)：</div>
                    <img  :src="loginImg" alt="" width="150" height="150">
                </el-col>
                <el-col :span="7">
                    <label style="width:120px;">跳转链接：</label>
                    <el-input style="width:280px;" v-model="toUrl" placeholder="（选填）点击图片跳转的链接"></el-input>
                </el-col>
                <el-col style="width:100px;" :span="1">
                    <el-button type="primary" @click="updateImg">更新</el-button>
                </el-col>
                <el-col style="width:100px;" :span="1">
                    <el-button type="danger" @click="deleteImg">一键清空数据</el-button>
                </el-col>
            </el-row>

        </div>


        <div class="section1">
            <h4>微信客服链接</h4>
            <el-row>
                <el-col :span="7">
                    <el-input v-model="kefuUrl" label="请输入客服链接"></el-input>
                </el-col>
                <el-col style="width:100px;" :span="1">
                    <el-button type="primary" @click="updateKefuUrl">更新</el-button>
                </el-col>
            </el-row>
        </div>




    </div>
</template>

<script>
import { saveAgentWithdrawConfig, getAgentWithdrawConfig } from '@/api/system.js'
import common from '@/utils/common.js'

export default {
    data() {
        return {
            huanka: {
                'appPopType': 1,
                'title': null,
                'context': null,
                'appPopValue': null
            },
            loginRemark: '',
            lunTrue1: false,
            lunTrue2: false,
            lunTrue3: false,
            lunbo1: {
                'appPopType': 1,
                'appPopImg': null,
                'appImgCount': null,
                'appPopValue': null
            },
            lunbo2: {
                'appPopType': 1,
                'appPopImg': null,
                'appImgCount': null,
                'appPopValue': null
            },
            linkStateOption: [
                { 'id': 3, 'name': '跳转第三方链接' },
                { 'id': 4, 'name': '跳转APP内部链接' }
            ],
            bindPhoneOption: [
                { 'id': 5, 'name': '国政通验证' },
                { 'id': 6, 'name': '手机号验证' },
                { 'id': 9, 'name': '不需要认证' }
            ],
            lunbo3: {
                'appPopType': 1,
                'appPopImg': null,
                'appImgCount': null,
                'appPopValue': null
            },
            secondBackState: '',
            dayOfBack: 100,
            maxMoney: 5,
            bindState: 9,
            isUserOpen: '',
            isAdminOpen: '',
            day: 1,
            coupon: {
                "is_enable": 0,
                "id": null,
                "title": ''
            },
            couponList: [],
            loading: false,
            cashoutMinAmount: null,
            cashoutFee: null,
            cashoutData: null,
            invent: '',

            //购卡金额
            buyCardCost: '',
            isNable: '',

            //购卡配置是否显示
            flag: false,

            kefuUrl: '',

            loginImg:'',
            toUrl:''
        }
    },
    methods: {
        deleteImg(){
            common.sysRequest("pkg/delete/img", {}, 'get').then(res => {
                if (res.data.code == 200) {
                    this.loginImg ="";
                    this.toUrl="";
                } 
            }).catch(err => console.error(err));
        },
        selectLoginImg() {
            common.sysRequest("pkg/login/img", {}, 'get').then(res => {
                if (res.data.code == 200) {
                    this.loginImg = process.env.VUE_APP_IMG_URL + '/' + res.data.data.loginImg;
                    this.toUrl=res.data.data.loginUrl;
                } 
            }).catch(err => console.error(err));
        },
        updateImg() {
            let fd = new FormData();
            fd.append('title', this.$refs.file1.files[0]);
            fd.append('toUrl',this.toUrl);
            common.sysRequest("pkg/update/login/img", fd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.loginImg = process.env.VUE_APP_IMG_URL + '/' + res.data.data;
                } 
            }).catch(err => console.error(err));
        },



        updateKefuUrl() {
            common.sysRequest("sysConfig/set/kefuUrl", { kefuUrl: this.kefuUrl }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },

        selectKefuUrl() {
            common.sysRequest("sysConfig/get/kefuUrl", {}, 'post').then(res => {
                if (res.data.code == 200) {
                    this.kefuUrl = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },



        setLoginRemark() {
            common.sysRequest("sysConfig/set/login/remark", { userRemark: this.loginRemark }, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },

        getLoginRemark() {
            common.sysRequest("sysConfig/get/login/remark", {}, 'post').then(res => {
                if (res.data.code == 200) {
                    this.loginRemark = res.data.data;
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        secondBackDiagnoseHandler() {
            this.lunbo1.appImgCount = 'appChart4';
            let fd = new FormData();
            Object.keys(this.lunbo1).forEach((key) => {
                fd.append(key, this.lunbo1[key]);
            })
            fd.append('appPopImg', this.$refs.file1.files[0]);
            common.sysRequest("app/pc/chart/updates", fd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.selectAll();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        secondBackDiagnoseHandler1() {
            this.lunbo2.appImgCount = 'appChart5';
            let fd = new FormData();
            Object.keys(this.lunbo2).forEach((key) => {
                fd.append(key, this.lunbo2[key]);
            })
            fd.append('appPopImg', this.$refs.file2.files[0]);
            common.sysRequest("app/pc/chart/updates", fd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.selectAll();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        secondBackDiagnoseHandler2() {
            this.lunbo3.appImgCount = 'appChart6';
            let fd = new FormData();
            Object.keys(this.lunbo3).forEach((key) => {
                fd.append(key, this.lunbo3[key]);
            })
            fd.append('appPopImg', this.$refs.file3.files[0]);
            common.sysRequest("app/pc/chart/updates", fd, 'post').then(res => {
                if (res.data.code == 200) {
                    this.selectAll();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }

            }).catch(err => console.error(err));
        },
        getWithdrawConfigHandle() {
            getAgentWithdrawConfig({}).then(res => {
                if (res.data.code == 200) {
                    if (res.data.data.cashoutMinAmount) {
                        this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                    }

                    if (res.data.data.cashoutFee) {
                        this.cashoutFee = res.data.data.cashoutFee;
                    }
                    if (res.data.data.cashoutData) {
                        this.cashoutData = res.data.data.cashoutData;
                    }
                }
            })
        },

        //收款配置
        saveWithdrawConfigHandle() {
            if (this.cashoutMinAmount == null || this.cashoutMinAmount == '') {
                this.$message.error('请输入最小提现金额');
                return;
            }
            if (this.cashoutFee == null || this.cashoutFee == '') {
                this.$message.error('请输入单笔手续费');
                return;
            }
            if (this.cashoutData == null || this.cashoutData == '') {
                this.$message.error('请输入提现间隔天数');
                return;
            }
            let d = {
                cashoutMinAmount: Number(this.cashoutMinAmount),
                cashoutFee: Number(this.cashoutFee),
                cashoutData: Number(this.cashoutData)
            }

            this.$confirm("确定保存此配置吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                saveAgentWithdrawConfig(d).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                        this.getWithdrawConfigHandle();
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {

            });
        },

        //查看购卡金额
        lookBuyCardCost() {
            common.sysRequest('bindPhone/buy/sim/price', {}, 'post').then(res => {
                if (res.data.code == 200) {
                    let result = res.data.data;
                    this.buyCardCost = result.agent_price / 100;
                    this.isNable = result.isNable;
                    this.invent = result.invent;
                }
            })
        },
        //更新购卡金额
        updateBuyCardCost() {
            this.$confirm("确定要保存吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let data = {
                    price: this.buyCardCost * 100,
                    isNable: this.isNable
                }
                common.sysRequest('bindPhone/update/sim/price', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                        this.lookBuyCardCost();
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {

            });
        },
        //更新购卡金额
        updateBuyCardCost1() {
            this.$confirm("确定要保存吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let data = {
                    id: this.invent,
                    isNable: this.isNable
                }
                common.sysRequest('bindPhone/update/invent/price', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                        this.lookBuyCardCost();
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {

            });
        },
        //是否显示购卡配置
        showbuyconfig() {
            if (sessionStorage.getItem("isCollect") == 1) {
                this.flag = false
            }
            else {
                this.flag = true
            }
        }
    },

    created() {
        this.selectLoginImg();
        this.selectKefuUrl();
        this.getLoginRemark();
        this.getWithdrawConfigHandle();
        this.lookBuyCardCost();
        this.showbuyconfig();
    }
}
</script>

<style lang="less" scoped>
#myConfig {
    font-size: 13px;

    .section1 {
        margin-bottom: 50px;

        h4 {
            font-size: 13px;
            font-weight: bold;
            padding-left: 5px;
            margin-bottom: 20px;
            margin-left: -8px;
            border-left: 3px solid #409eff;
        }

        label {
            display: inline-block;
        }

        .el-row {
            margin-bottom: 20px;
        }

        span {
            text-align: left;
        }
    }


}
</style>

